"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _uiKit = require("@devsta/ui-kit");

var _memoizeOne2 = _interopRequireDefault(require("memoize-one"));

var _getAssetMetaDataField = _interopRequireDefault(require("../../../../../../../../OrderClips/utils/getAssetMetaDataField"));

var _utils = require("../../../../../../../../../../../common/utils");

require("../styles/_asset-dropdown.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AssetLabel = (0, _commonReact.withAssetSelector)(function (_ref) {
  var asset = _ref.asset;
  var duration = (0, _getAssetMetaDataField.default)('duration', asset, {
    fallback: 0
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "asset-dropdown__option"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true,
    highlighted: true
  }, asset && asset.title), duration ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true,
    timestamp: true
  }, (0, _utils.convertSecondsToReadable)(duration, {
    hideMillis: true
  })) : null);
});
var getDropdownOption = (0, _memoizeOne2.default)(function (assetId) {
  return {
    label: /*#__PURE__*/_react.default.createElement(AssetLabel, {
      assetId: assetId
    }),
    prefix: /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
      width: "75px",
      height: "75px",
      assetId: assetId
    }),
    value: assetId
  };
});
var getDropdownOptions = (0, _memoizeOne2.default)(function (assetIds) {
  return assetIds.map(getDropdownOption);
}, _lodash.default);

function AssetDropdown(_ref2) {
  var _ref2$assetIds = _ref2.assetIds,
      assetIds = _ref2$assetIds === void 0 ? [] : _ref2$assetIds,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      selectedId = _ref2.selectedId,
      onSelect = _ref2.onSelect,
      disabled = _ref2.disabled;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
    className: "asset-dropdown",
    options: getDropdownOptions(assetIds),
    label: label,
    placeholder: placeholder,
    onChange: onSelect,
    value: selectedId ? getDropdownOption(selectedId) : null,
    height: "auto",
    fontSize: 12,
    hideSeparators: true,
    disabled: disabled,
    type: "BUTTON"
  });
}

var _default = /*#__PURE__*/(0, _react.memo)(AssetDropdown);

exports.default = _default;